import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
    :root {
        --bg: #F9F7F7;
        --main: #181818;
        --sub: #5F5F5F;
        --primary: #FF0066;
        --error: #FF000F;
        --success: #51c549;
        --shadow-color:#00000014;
        --white:#ffffff;
        --icon-filter: brightness(0) saturate(100%) invert(16%) sepia(98%) saturate(7069%) hue-rotate(330deg) brightness(104%) contrast(106%);
        --kusari-green: #689778;
        --site-header-height: 7.6rem;
    }

    @media only screen and (max-width: 750px) {
        :root {
            --site-header-height: 7.8rem;
        }
    }

    html {
        font-size: 62.5%;
        height: 100%;
    }

    body {
        min-height: 100%;
    }

    body,
    #root {
        height: 100%;
    }

    @media only screen and (min-width: 1001px) {
        html.home-snap-scroll,
        html.home-snap-scroll body,
        html.home-snap-scroll #root {
            height: 100%;
            overflow: hidden;
        }
    }

    @media only screen and (max-width: 1000px) {
        html.home-snap-scroll,
        html.home-snap-scroll body,
        html.home-snap-scroll #root {
            height: auto;
            overflow: visible;
        }
    }

    * {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
        color: var(--main);
        font-family: "Space Grotesk", sans-serif;
    }

    button {
        background: none;
        border: none;
    }

    input {
        border: none;
    }

    /* Keep focus invisible for pointer clicks but visible for keyboard users. */
    button:focus:not(:focus-visible),
    input:focus:not(:focus-visible),
    a:focus:not(:focus-visible) {
        outline: none;
    }

    button:focus-visible,
    input:focus-visible,
    a:focus-visible,
    [tabindex]:focus-visible {
        outline: 2px solid var(--primary);
        outline-offset: 2px;
    }

    a {
        text-decoration: none;
    }

    p {
        font-weight: 400;
    }
`;
// ThemedGlobalStyledClassProps
const GlobalStyles = (): JSX.Element => {
  return <GlobalStyle />;
};

export default GlobalStyles;
